import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HotRecommend() {
  const hotMovies = movies.filter(m => m.tags.includes('热门') || m.tags.includes('推荐')).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              热门推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              大家都在看的精彩内容
            </p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.slug}`}
              className="group cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="relative rounded-xl overflow-hidden aspect-[3/4] mb-3">
                <img
                  src={movie.poster}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2 flex flex-wrap gap-1">
                  {movie.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-primary-500/90 text-background-50 text-xs rounded-md font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-background-950/70 text-accent-400 text-xs rounded-md font-bold">
                    {movie.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                {movie.title}
              </h3>
              <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                <span>{movie.type}</span>
                <span>·</span>
                <span>{movie.year}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/movie"
            className="flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}